import { FC, useContext } from "react";

import { isGroupAccessId, isStudentAccessId } from "../../../../shared/access-id";
import { useNameFromPageAccessId } from "../helpers";

import { SUBMISSION_ID_QUERY_PARAM } from "components/constants";
import { t } from "i18n/i18n";
import { Banner } from "mds/components/Banner";
import { DocViewContext, PageTabVariant } from "providers/DocViewProvider";
import { useAppSelector } from "store";
import { useCapabilities } from "store/capability-hooks";
import { selectIsEditModeEnabled } from "store/selectors";
import { useQueryParam } from "utils/routing";

type InstructorEditingStudentDraftBannerProps = {
  pageId: string;
  selectedTabVariant?: PageTabVariant;
};

export const InstructorEditingStudentDraftBanner: FC<InstructorEditingStudentDraftBannerProps> = ({
  pageId,
  selectedTabVariant,
}) => {
  const { accessId, readOnly } = useContext(DocViewContext);
  const { canEditStudentDraft } = useCapabilities();
  const isEditModeEnabled = useAppSelector(selectIsEditModeEnabled);
  const submissionId = useQueryParam(SUBMISSION_ID_QUERY_PARAM);

  const isStudentResponsesTab = selectedTabVariant === "responses";
  const isViewingSubmission =
    Boolean(submissionId) && submissionId !== "draft" && submissionId !== "null";

  const showInstructorEditingStudentDraftBanner =
    isStudentResponsesTab &&
    (isStudentAccessId(accessId) || isGroupAccessId(accessId)) &&
    canEditStudentDraft &&
    isEditModeEnabled &&
    !readOnly &&
    !isViewingSubmission;

  const studentOrGroupName = useNameFromPageAccessId(accessId, pageId);
  if (!studentOrGroupName || !showInstructorEditingStudentDraftBanner) {
    return null;
  }

  return (
    <Banner className="page-block-width" kind="warning">
      {t("warning.editing_student_workspace", { name: studentOrGroupName })}
    </Banner>
  );
};
